<template>
  <slot v-bind="bindings"></slot>
  <dialog ref="dialog" class="c-base-dialog" v-bind="$attrs">
    <div class="p-box-padding">
      <slot name="content" v-bind="bindings">
        <h2
          v-if="title"
          class="text-25 font-bold whitespace-pre-wrap mb-[10px]"
          v-html="title"
        ></h2>
        <div v-if="text" class="s-rich-text" v-html="text"></div>
      </slot>
      <slot></slot>
    </div>
    <div
      method="dialog"
      class="flex items-center gap-[10px] p-box-padding py-[10px] bg-[rgba(0,51,73,.05)]"
    >
      <slot name="actions" v-bind="bindings">
        <BaseButton
          class="ml-auto bg-text text-white hover:bg-green-dark"
          autofocus
          @click="bindings.toggle(false)"
        >
          Luk
        </BaseButton>
      </slot>
    </div>
  </dialog>
</template>

<script setup>
const props = defineProps({
  title: {
    type: String,
    default: null,
  },
  text: {
    type: String,
    default: null,
  },
  onClose: {
    type: Function,
    default: null,
  },
  startOpen: {
    type: Boolean,
    default: false,
  },
});

const dialog = ref(null);
const isOpen = ref(false);
const bindings = ref({
	title: props.title,
	text: props.text,
	toggle(state) {
		isOpen.value = state;
	},
});

watchEffect(() => {
  if (isOpen.value) {
    if (
      dialog.value &&
      !dialog.value.open &&
      document.body.contains(dialog.value)
    ) {
      dialog.value.showModal?.();
    }
  } else {
    if (
      dialog.value &&
      dialog.value.open &&
      document.body.contains(dialog.value)
    ) {
      dialog.value.close?.();
    }
  }
});
onMounted(() => {
  if (
    props.startOpen &&
    dialog.value &&
    !dialog.value.open &&
    document.body.contains(dialog.value)
  ) {
    isOpen.value = true;
    dialog.value?.showModal?.();
  }
  dialog.value.addEventListener("close", (e) => {
    isOpen.value = false;
    props.onClose?.(e);
  });
});
</script>

<script>
export default {
  inheritAttrs: false,
};
</script>

<style lang="postcss">
.c-base-dialog {
  @apply fixed text-16 text-text inset-[0px] w-fit min-w-[min(470px,80vw)] max-w-[26.25em] m-auto p-[0px];
  bottom: max(0px, 75vh - 400px);

  &::backdrop {
    background-color: rgba(0, 38, 54, 0.8);
    backdrop-filter: blur(3px);
  }
}
</style>
